<template>
<el-dialog
    append-to-body
    class="rtportal rt-lookup-dialog big-dialog"
    :close-on-click-modal="false"
    :title="lookupTitle"
    :visible.sync="dialogVisible"
  >
    <el-row>
      <el-col :span="4">{{ $tx("搜索") }}</el-col>
      <el-col :span="20">
        <el-input
          v-model="filterValue"
          @keyup.enter.native="handleSearch"
          :placeholder="placeholder"
        >
          <el-button
            type="text"
            slot="append"
            icon="el-icon-search"
            style="margin-top: -16px"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      ref="lookupTable"
      style="width: 100%"
      height="57%"
      :row-class-name="tabRowClassName"
      highlight-current-row
      :header-cell-style="{ background: '#F0F3F7' }"
      v-bind:data="tableData"
      border
      stripe
      @current-change="handleCurrentChange"
      @row-dblclick="handleConfirm"
      @sort-change="handleSortChange"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row == currentRow&&!multiple"></i>
        </template>
      </el-table-column>
      <el-table-column v-if="multiple" type="selection" width="50"></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        v-for="display in displayFields"
        v-bind:key="display.name"
        :prop="display.name"
        :label="display.label"
        :width="display.width"
      ></el-table-column>
      <template slot="empty">
        <img
          style="margin-top: 50px"
          src="../../../src/assets/imgs/home/no-order.png"
          alt
        />
        <p class="nodata-prompt">Sorry！未找到相应结果哦~换个关键词试试！</p>
      </template>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleIndexChange"
      :current-page="pageIndex"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :layout="layout"
      :total="totalRecordCount"
      style="text: center; margin: 1% 0; text-align: center"
    ></el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleReset">{{
       $tx("移除值")
      }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{
        $tx("确 定")
      }}</el-button>
    </span>
  </el-dialog>
</template>
  
  <script>
  export default {
    name: "RtLookupMultipleDialog",
    props: {
      entity: {
        type: String,
        required: true,
      },
      placeholder:{
        type:String,
        default:"请选择"
      },
      lookupTitle: {
        type: String,
        required: false,
        default: 'lookup.title'
      },
      requestUrl: {
        type: String,
        default: function () {
          return "../api/crmlookupview/data";
        },
      },
      nameField: {
        type: String,
        default: function () {
          return "new_name";
        },
      },
      multiple: {
        type: Boolean
      },
      idField: {
        type: String,
        default: function () {
          return this.entity + "id";
        },
      },
      displayFields: {
        type: Array,
        default: function () {
          return [
            { name: "new_name", label: this.$tx("名称") },
            {
              name: "createdon",
              label: this.$tx("创建时间"),
              width: 180,
            },
          ];
        },
      },
      orderbyFields: {
        type: String,
        default: function () {
          return "createdon desc";
        },
      },
      customConditions: {
        type: String,
        default: function () {
          return "";
        },
      },
      filterFields: {
        type: String,
        default: function () {
          return "new_name";
        },
      },
      returnFields: {
        type: String,
      },
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
  
        filterValue: "",
  
        pageIndex: 1,
        pageSize: 20,
        layout: "total, sizes, prev, pager, next",
        pageSizes: [10, 20, 30, 40, 50],
        totalRecordCount: 0,
  
        tableData: [],
        currentRow: null,
      };
    },
    computed: {
      dialogTitle() {
        return "查找";
      },
      selectString: {
        get() {
          //将idField、nameField、displayFields、returnFields合并，并去掉重复的字段
          var selectFields;
  
          if (this.returnFields) {
            selectFields = this.returnFields.split(",");
          } else {
            selectFields = [];
          }
          selectFields.push(this.nameField);
          selectFields.push(this.idField);
  
          for (var i in this.displayFields) {
            var fieldName = this.displayFields[i].name;
            if(fieldName.indexOf('.') >= 0) {
              fieldName = fieldName.split(".")[0];
            }
            if (selectFields.indexOf(fieldName) >= 0) {
              continue;
            }
            selectFields.push(fieldName);
          }
  
          return selectFields.join(",");
        },
      },
      orderbyString: {
        get() {
          return this.orderbyFields;
        },
      },
      conditionString: {
        get() {
          return this.customConditions;
        },
      },
      filterString: {
        get() {
          return this.filterFields;
        },
      },
    },
    mounted() {
      
    },
    methods: {
      handleSelectionChange(selectedRows) {
      // 处理多选数据
      console.log('Selected rows:', selectedRows);
      this.selectedRows = selectedRows;
    },
      //在methods总通过方法计算返回对应class样式
      tabRowClassName({ row, rowIndex }) {
        let index = rowIndex + 1;
        if (index % 2 == 0) {
          return "even-row";
        }
      },
      show() {
        this.dialogVisible = true;
  
        this.pageIndex = 1;
        this._fetchRecords();
      },
      handleSearch() {
        this.pageIndex = 1;
        this._fetchRecords();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      handleSortChange() {
        alert("未实现");
      },
      handleSizeChange(pageSize) {
        this.pageSize = pageSize;
  
        this._fetchRecords();
      },
      handleIndexChange(pageIndex) {
        this.pageIndex = pageIndex;
  
        this._fetchRecords();
      },
      handleReset() {
        this.$emit("data-selected", {
          id: null,
          logicalName: this.logicalName,
          name: null,
        });

        this.dialogVisible = false;
      },
      //确定事件
      handleConfirm() {
    var selectedRows = this.$refs.lookupTable.store.states.currentRow;
  
    if (this.multiple) {
      selectedRows = this.$refs.lookupTable.store.states.selection;
    }
  
    if (rt.isNull(selectedRows) || (this.multiple && selectedRows.length === 0)) {
      rt.showErrorToast("请选择一条记录");
      return;
    }
  
    // 为多选提前单选变量
    if (!this.multiple) {
      selectedRows = [selectedRows];
    }
  
    var retValues = selectedRows.map((selectedRow) => {
      var retValue = {
        id: selectedRow[this.idField],
        name: selectedRow[this.nameField],
        ...selectedRow
      };
  
      if (this.returnFields) {
        var fieldList = this.returnFields.split(",");
        for (var i in fieldList) {
          retValue[fieldList[i]] = selectedRow[fieldList[i]];
        }
      }
  
      return retValue;
    });
  
    // 如果是单选, 返回对象而非数组
    this.$emit("data-selected", this.multiple ? retValues : retValues[0]);
  
    this.dialogVisible = false;
  },
      //数据加载
      _fetchRecords() {
        this.loading = true;
        var requestStr = this.requestUrl;
        if (requestStr.indexOf("?") >= 0) {
          requestStr = this.requestUrl + "&entityName=" + this.entity;
        } else {
           requestStr = this.requestUrl + "?entityName=" + this.entity;
        }
        requestStr =
          requestStr +
          "&page=" +
          this.pageIndex +
          "&count=" +
          this.pageSize +
          "&select=" +
          this.selectString +
          "&orderby=" +
          this.orderbyString +
          "&condition=" +
          this.conditionString +
          "&filter=" +
          this.filterString +
          "&filterValue=" +
          encodeURIComponent(this.filterValue || "");
        rt.get(requestStr)
          .then((res) => {
            this.tableData = res.Data;
            this.totalRecordCount = res.TotalRecordCount;
  
            this.$nextTick(() => {
              this.$refs.lookupTable.doLayout();
            });
  
            this.loading = false;
          })
          .catch((error) => {
            rt.showErrorToast(error);
  
            this.loading = false;
          });
      },
    },
  };
  </script>
  
  <style>
  .rt-lookup-dialog .el-dialog {
    min-width: 550px;
  }
  
  .rt-lookup-dialog .el-form-item .el-form-item__label {
    width: 120px;
  }
  
  .rt-lookup-dialog .el-form-item .el-form-item__label:before {
    display: none;
  }
  
  .rt-lookup-dialog .el-form-item .el-form-item__content {
    margin-left: 120px !important;
  }
  
  .rt-lookup-dialog .el-table {
    margin-top: 15px;
  }
  
  .rt-lookup-dialog .el-dialog__body {
    padding-bottom: 15px;
  }
  .big-dialog .el-row {
    padding: 15px 20px 0 15px;
    line-height: 2;
    color: #143e81 !important;
  }
  
  .rt-lookup-dialog .el-input__validateIcon {
    display: none;
  }
  .rt-lookup-dialog .el-pagination .btn-prev .el-icon,
  .rt-lookup-dialog .el-pagination .btn-next .el-icon {
    margin-right: 10px;
  }
  .rt-lookup-dialog .el-pagination {
    height: 90px;
  }
  </style>
  
  


// WEBPACK FOOTER //
// lookup-multiple-dialog.vue?afa1c9a4